import React from 'react'

import SEO from "../../components/Head/Social"

import Navigation from '../../components/Landing/Navigation'
import BlogList from '../../components/Landing/BlogList'
import Footer from '../../components/Landing/Footer'

import matter from 'gray-matter'

export const getStaticProps = async () => {
	const fs = require('fs')
	const files = fs.readdirSync(`${process.cwd()}/posts`, 'utf-8')
	const data = files.map((blog) =>
		({content: fs.readFileSync(`${process.cwd()}/posts/${blog}/index.md`, { encoding: 'utf-8' }), slug: blog}))
	return { props: { data } }
}

const BlogListPage = ({data}) => {
  const content = data.map((blog) => ({...matter(blog.content), slug: blog.slug}))
  return (
    <>
      <SEO title="Blog" />
      <Navigation />
      <BlogList posts={content}/>
      <Footer />
    </>
)}
export default BlogListPage
